// src/features/publicProfile/slices/publicProfileReducer.ts
import { createSlice } from '@reduxjs/toolkit';
import { getPublicProfile, getPublicUserActivities } from '../actions/publicProfileActions';

interface PublicProfileState {
  user: any | null;
  profile: any | null;
  activities: {
    discussions: any[];
    comments: any[];
    upvoted_blogs: any[];
  } | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: PublicProfileState = {
  user: null,
  profile: null,
  activities: null,
  isLoading: false,
  error: null,
};

const publicProfileSlice = createSlice({
  name: 'publicProfile',
  initialState,
  reducers: {
    clearPublicProfile: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPublicProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPublicProfile.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.profile = action.payload.profile;
        state.isLoading = false;
      })
      .addCase(getPublicProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to load profile';
      })
      .addCase(getPublicUserActivities.pending, (state) => {
        // Optional: Add loading state for activities
        state.error = null;
      })
      .addCase(getPublicUserActivities.fulfilled, (state, action) => {
        // console.log('Setting public activities:', action.payload);
        state.activities = {
          discussions: action.payload.discussions || [],
          comments: action.payload.comments || [],
          upvoted_blogs: action.payload.upvoted_blogs || [],
        };
      })
      .addCase(getPublicUserActivities.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to load activities';
        // Set empty activities on error
        state.activities = {
          discussions: [],
          comments: [],
          upvoted_blogs: [],
        };
      });
  },
});

export const { clearPublicProfile } = publicProfileSlice.actions;
export default publicProfileSlice.reducer;